import {pendoService} from '@/modules/common/services'
const hotjarScript = "(function(h,o,t,j,a,r){h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};h._hjSettings={hjid:188885,hjsv:6};a=o.getElementsByTagName('head')[0];r=o.createElement('script');r.async=1;r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;a.appendChild(r);})(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');"
const fullStoryScript = "window['_fs_debug']=false;window['_fs_host']='fullstory.com';window['_fs_script']='edge.fullstory.com/s/fs.js';window['_fs_org']='1RNSF';window['_fs_namespace']='FS';(function(m,n,e,t,l,o,g,y){if(e in m){if(m.console&&m.console.log){m.console.log('FullStory namespace conflict. Please set window[_fs_namespace].');}return;} g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};g.anonymize=function(){g.identify(!!0)};g.shutdown=function(){g('rec',!1)};g.restart=function(){g('rec',!0)};g.log=function(a,b){g('log',[a,b])};g.consent=function(a){g('consent',!arguments.length||a)};g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};g.clearUserCookie=function(){};g.setVars=function(n,p){g('setVars',[n,p]);};g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};g._v='1.3.0';})(window,document,window['_fs_namespace'],'script','user');"
const smartLookScript = "window.smartlook||(function(d) {var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';c.charset='utf-8';c.src='https://rec.smartlook.com/recorder.js';h.appendChild(c);})(document);smartlook('init', '68a9d1522088eb7350ed63d98be45739c7e2a8e5');"
//For vcita direct users
const logRocketDirectSrc = "https://cdn.lr-in.com/LogRocket.min.js"
const logRocketDirectScript = "window.LogRocket && window.LogRocket.init('ha3rwe/vcita',{mergeIframes: true})"

// build scripts only once
let firstRun = true

const set = (account, conditions = {}, data = {}) => {
  let pendoEnabled = account.external_integrations.pendo.enabled
  if (firstRun) {
    if (pendoEnabled) {
      let pendoAPIkey = (conditions?.isMobile || conditions?.isMobileApp)  ? account.external_integrations.pendo.mobile : account.external_integrations.pendo.desktop
      pendoService.buildPendo(pendoAPIkey)
    }
    if (account.business.has_logrocket_script) runLogrocketScript(account)
    if (conditions?.hasFeature('session_recording')){
      addScriptToWindow('hotjar_script',hotjarScript)
      addScriptToWindow('fullStory_script',fullStoryScript)
      addScriptToWindow('smartlook_script',smartLookScript)
      runLogRocketDirectScript(account, conditions.isMobile, conditions.isMobileApp)
    }
  }
  // sending data that depends on the user activities - so we call the function more than once
  if (pendoEnabled) pendoService.initPendo(account, conditions?.isStar, conditions?.isMobile, data?.matterTerm, data?.numOfStaff)

  firstRun = false
}

function runLogrocketScript(account){
  let logrocket_event_method = account.brand.logrocket_script[0]
  let logrocket_src_script = account.brand.logrocket_script[1]
  let logrocket_script =  account.brand.logrocket_script[2]
  let data = {
    "%THRYV_ID%": account.business.uid,
    "%NAME%": account.staff.full_name.replace(/[^a-zA-Z0-9 ]/g, ""),
    "%STAFF_ID%": account.staff.uid,
    "%LOGIN_EMAIL%": account.staff.email
  }
  for (const property in data) {
    logrocket_script = logrocket_script.replace(property, data[property])
  }
  let method_element = document.createRange().createContextualFragment(logrocket_event_method)
  document.head.appendChild(method_element)
  let src_element = document.createRange().createContextualFragment(logrocket_src_script)
  document.head.appendChild(src_element)
  let element = document.createRange().createContextualFragment(logrocket_script)
  document.head.appendChild(element)
}



export default {
  set
};

function runLogRocketDirectScript(account, mobile, mobileApp){
  addScriptSrcToWindow('#logrocket', logRocketDirectSrc, "anonymous")
  setTimeout(() => {
    addScriptToWindow('#logrocket_script', logRocketDirectScript)
    let data = {
      email: account.staff.email,
      staff_id: account.staff.uid,
      mobile_app: !!mobileApp,
      mobile_web: !!mobile
    }
    if (window.LogRocket && window.LogRocket.identify)
      window.LogRocket.identify("uid-" + account.staff.uid, data)
  },1500)
}

function addScriptToWindow(id, script){
  let element = document.createElement('script')
  element.innerHTML = script
  element.setAttribute('id',id)
  document.getElementsByTagName('head')[0].appendChild(element)
}

function addScriptSrcToWindow(id, src, crossorigin = null){
  let element = document.createElement('script')
  element.src = src
  if (crossorigin) element.crossorigin = crossorigin
  element.setAttribute('id', id)
  document.getElementsByTagName('head')[0].appendChild(element)
}
